
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 5a1 1 0 000 2h.01a1 1 0 000-2H3zm5 0a1 1 0 000 2h13a1 1 0 100-2H8zm0 6a1 1 0 100 2h13a1 1 0 100-2H8zm-1 7a1 1 0 011-1h13a1 1 0 110 2H8a1 1 0 01-1-1zm-5-6a1 1 0 011-1h.01a1 1 0 110 2H3a1 1 0 01-1-1zm1 5a1 1 0 100 2h.01a1 1 0 100-2H3z","fill":"#04080E"}})])
          )
        }
      }
    